import PropTypes from 'prop-types';

import BaseUrgencyMessage from '../BaseUrgencyMessage/BaseUrgencyMessage';
import {
    getIconProps
} from '../../helpers/helpers';

export default class UrgencyMessage extends BaseUrgencyMessage {
    static propTypes = {
        /** Optional classname to override the root styling */
        className: PropTypes.string,
        /** Sets size and behavior of font and icon */
        size: PropTypes.string,
        /** Data to use in rendering component */
        unitMessage: PropTypes.oneOfType([
            PropTypes.shape({
                iconTextV1: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                }),
            }),
            PropTypes.shape({
                iconTextV2: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                }),
            }),
            PropTypes.shape({
                iconText: PropTypes.shape({
                    icon: PropTypes.string,
                    message: PropTypes.string
                }),
            })
        ]),
        color: PropTypes.bool,
        ariaHidden: PropTypes.bool
    };

    // eslint-disable-next-line complexity
    render() {
        const {className, size, unitMessage, color, ariaHidden} = this.props;
        const {iconTextV1, iconTextV2, iconText} = unitMessage || {};

        if (!iconTextV1 && !iconTextV2 && !iconText) {
            return null;
        }

        const {icon, message} = iconTextV1 || iconTextV2 || iconText;
        const {style, src} = getIconProps(icon, size, color);

        return this.generateComponent({
            className,
            style,
            src,
            icon,
            message,
            size,
            ariaHidden
        });
    }
}
